import * as React from 'react';
import { Container, Header, KeyValuePairs, Textarea } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { getNotificationBatches, getNotifications } from 'src/api/notifications';
import { getPhoneToolLink } from 'src/commons/common';

//include respond comment information if the comment respond to another comment
export const CommentLine = ({ comment }) => (
  <>
    <Container
      disableHeaderPaddings
      disableContentPaddings
      header={
        <Header
          description={
            comment.RespondNotificationCommentId != null && (
              <div>
                &nbsp;&nbsp;&nbsp;Replied to {comment.RespondUserId} ({comment.SenderId}):{' '}
                {comment.RespondNotificationCommentContent}
              </div>
            )
          }
        >
          <h5>
            &nbsp;&nbsp;{comment.NotificationOwnerId} ({comment.SenderId}) commented at{' '}
            {new Date(comment.CreateTime).toLocaleString()}
          </h5>
        </Header>
      }
    >
      <Textarea value={comment.NotificationCommentContent} ariaRequired={true} readOnly></Textarea>
    </Container>
  </>
);

//list data for inbox notifications
export const NotificationInboxDetail = ({ notification }) => (
  <KeyValuePairs
    columns={4}
    items={[
      {
        label: 'Sender alias',
        value: getPhoneToolLink(notification.selectedSenderUserId),
      },
      { label: 'Sender group', value: notification.selectedSenderGroupId },
      { label: 'Priority level', value: notification.selectedPriorityLevel },
      { label: 'Email sent', value: notification.selectedEmailSent ? 'Sent' : 'Not sent' },
      { label: 'Create time', value: new Date(notification.selectedCreateTime).toLocaleString() },
    ].filter((item) => item != undefined)}
  />
);

//list data for archived notifications
export const NotificationArchiveDetail = ({ notification }) => (
  <KeyValuePairs
    columns={4}
    items={[
      {
        label: 'Sender alias',
        value: getPhoneToolLink(notification.selectedCreateTime),
      },
      { label: 'Sender group', value: notification.selectedSenderGroupId },
      { label: 'Priority level', value: notification.selectedPriorityLevel },
      { label: 'Email sent', value: notification.selectedEmailSent ? 'Sent' : 'Not sent' },
      { label: 'Create time', value: new Date(notification.selectedCreateTime).toLocaleString() },
      { label: 'Archive time', value: new Date(notification.selectedArchiveTime).toLocaleString() },
      { label: 'Archived by', value: notification.selectedArchivedBy },
    ].filter((item) => item != undefined)}
  />
);

//list data for notifications sent by group
export const NotificationSentDetail = ({ notification }) => (
  <div>
    <KeyValuePairs
      columns={1}
      items={[{ label: 'Receiver group list', value: notification.selectedGroupIdList.join('; ') }]}
    />
    <KeyValuePairs
      columns={4}
      items={[
        {
          label: 'Sender alias',
          value: getPhoneToolLink(notification.selectedSenderUserId),
        },
        { label: 'Sender group', value: notification.selectedSenderGroupId },
        { label: 'Priority level', value: notification.selectedPriorityLevel },
        { label: 'Email sent', value: notification.selectedEmailSent ? 'Sent' : 'Not sent' },
        { label: 'Create time', value: new Date(notification.selectedCreateTime).toLocaleString() },
        { label: 'Last update time', value: new Date(notification.selectedLastCommentTime).toLocaleString() },
      ].filter((item) => item != undefined)}
    />
  </div>
);

//update unread notifications
export const updateNotificationIcon = async (activeGroup, user) => {
  let request = {
    ReceiverId: activeGroup,
    Archive: false,
    Unread: true,
    NextToken: '',
  };

  let response = await getNotifications(request);
  let notificationList = [...response.NotificationList];
  let workspaceCount = response.WorkspaceCount;

  //Loop and get remaining tables
  while (response.NextToken != null) {
    request = {
      ReceiverId: activeGroup,
      Archive: false,
      Unread: true,
      NextToken: response.NextToken,
    };
    response = await getNotifications(request);
    notificationList.push(...response.NotificationList);
  }

  let notificationBatchRequest = {
    NotificationOwnerId: activeGroup,
    NextToken: '',
  };

  let notificationBatchResponse = await getNotificationBatches(notificationBatchRequest);

  let notificationBatchList = [...notificationBatchResponse.NotificationBatchList];

  while (notificationBatchResponse.NextToken != null) {
    notificationBatchRequest = {
      NotificationOwnerId: activeGroup,
      NextToken: notificationBatchResponse.NextToken,
    };
    notificationBatchResponse = await getNotificationBatches(notificationBatchRequest);
    notificationBatchList.push(...notificationBatchResponse.NotificationBatchList);
  }
  let commentedSentNotificationList = [];
  for (let notificationBatch of notificationBatchList) {
    if (
      notificationBatch.NotificationOwnerId == user &&
      notificationBatch.ReviewerList[notificationBatch.NotificationOwnerId] != null
    ) {
      commentedSentNotificationList.push(notificationBatch);
    }
  }
  return {
    unreadNotifications: notificationList,
    unreadNotificationBatches: commentedSentNotificationList,
    workspaceCount: workspaceCount,
  };
};
